import React from 'react';

export default function ThemeToggle({ theme, setTheme }) {
  const isDark = theme === 'dark';

  const styles = {
    button: {
      position: 'fixed',
      top: '1.25rem',
      right: '1.25rem',
      zIndex: 100,
      background: 'none',
      border: `1px solid ${isDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)'}`,
      borderRadius: '2rem',
      padding: '0.35rem 0.8rem',
      cursor: 'pointer',
      fontSize: '0.8rem',
      color: isDark ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.5)',
      letterSpacing: '0.05em',
      transition: 'color 0.2s, border-color 0.2s',
      fontFamily: 'var(--font)',
    },
  };

  return (
    <button
      style={styles.button}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      aria-label="Toggle color mode"
    >
      {isDark ? 'light' : 'dark'}
    </button>
  );
}
